export interface Event {
	bookero_service_id: String
	bookero_service_name: String
	date: String
	start_time: String
}

interface UserData {
	name: string
	email: string
	phone: string
}

export function DonationForm(event: Event, user: UserData) {
	const form = (
		<form action="https://secure.tpay.com/" method="post" name="payment">
			<input name="id" value="143381" type="hidden"/>
			<input name="kwota" value="40" type="hidden"/>
			<input name="md5sum" value="e116003b7c1e6614ad27aad658180901" type="hidden"/>
			<input name="email" value={user.email} type="hidden"/>
			<input name="nazwisko" value={user.name} type="hidden"/>
			<input name="opis" value={"darowizna na " + event.bookero_service_name} type="hidden"/>
			<input name="jezyk" value="PL" type="hidden"/>
			<button type="submit">Przekaż darowiznę 40 zł<br/>na organizację biegu</button>
			<p>Ewentualny nadmiar środków zostanie przeznaczony na inne cele pożytku publicznego realizowane przez stowarzyszenie Homokomando. Darowizny na Homokomando można odliczyć od podatku. <a href="../wspieraj.html">Więcej informacji o darowiznach na Homokomando.</a></p>
		</form>
	)

	form.addEventListener('submit', () => {
		try {
			fbq('track', 'Donate')
		} catch (e) {console.log(e)}
	})

	return form
}

export function RegistrationForm(event: Event) {
	const form = (
		<form id="zapisy">
			<fieldset>
				<fieldset>
					<label for="input-name"><strong>Imię i nazwisko</strong> (wybrane przez Ciebie)</label>
					<input type="text" name="name" id="input-name" required/>
				</fieldset>
				<fieldset>
					<label for="input-email"><strong>Adres e-mail</strong></label>
					<input type="email" name="email" id="input-email" required/>
				</fieldset>
				<fieldset>
					<label for="input-phone"><strong>Numer telefonu</strong></label>
					<input type="tel" name="phone" id="input-phone" required/>
				</fieldset>
				<dl>
					<dt>Cel przetwarzania:</dt>
					<dd>Przeprowadzenie biegu, zapewnienie bezpieczeństwa, informowanie o ewentualnych zmianach</dd>
				</dl>
				<dl>
					<dt>Podstawa przetwarzania:</dt>
					<dd>Niezbędne do wykonania umowy (art. 6 (1) (b) RODO)</dd>
				</dl>
				<dl>
					<dt>Czas przetwarzania:</dt>
					<dd>Do 7 dni po zakończeniu wydarzenia</dd>
				</dl>
			</fieldset>
			<div>
				<dl>
					<dt>Administrator danych:</dt>
					<dd>Stowarzyszenie Homokomando, <a href="mailto:zarzad@homokomando.pl">zarzad@homokomando.pl</a></dd>
				</dl>
				<dl>
					<dt>Twoje prawa:</dt>
					<dd>Masz prawo dostępu do swoich danych, ich sprostowania, usunięcia lub ograniczenia przetwarzania; a także do wniesienia skargi do UODO.</dd>
				</dl>
			</div>
			<button type="submit">Zapisz się</button>
		</form>
	) as HTMLFormElement
	form.addEventListener('submit', async e => {
		e.stopPropagation()
		e.preventDefault()

		const submitButton = form.querySelector('button[type="submit"]')!

		const data = new FormData(form)
		const userData = {
			name: data.get('name'),
			email: data.get('email'),
			phone: data.get('phone'),
		} as UserData

		const signUpForNewsletter = data.get('newsletter') === 'on'

		for (const fieldset of form.getElementsByTagName('fieldset')) {
			fieldset.disabled = true
		}
		for (const button of form.getElementsByTagName('button')) {
			button.disabled = true
		}
		form.classList.add('disabled')

		const plugin_comment = {
			data: {
				name: userData.name,
				phone: userData.phone,
				parameters: [],
				services_names: [{
					category: "Biegi Równości",
					value: event.bookero_service_name,
					require_people: 0,
				}],
				services_values: [{
					category: 6666,
					value: event.bookero_service_id,
					require_people: 0,
				}]
			}
		}
		const body = {
			bookero_id: "VKCIH68TrrM0",
			agree_tp: false,
			agree_newsletter: signUpForNewsletter,
			agree_telemarketing: false,
			discount_code: "",
			configuration_payment_id: 0,
			lang: "pl",
			cart_id: 0,
			name: userData.name,
			phone: userData.phone,
			email: userData.email,
			inquiries: [{
				plugin_comment: JSON.stringify(plugin_comment),
				phone: userData.phone,
				people: 1,
				date: event.date,
				hour: event.start_time,
				email: userData.email,
				service: event.bookero_service_id,
				worker: 0,
				periodicity_id: 0,
				custom_duration_id: 0,
				plugin_inquiry_id: null,
			}],
		}

		let maybeAlreadyRegistered = false

		try {
			const res = await (await fetch('https://plugin.bookero.pl/plugin-api/v2/add', {
				method: 'POST',
				headers: {
					'accept': 'application/json, text/plain, */*',
					'content-type': 'application/json',
				},
				referrerPolicy: 'strict-origin',
				mode: 'cors',
				credentials: 'omit',
				body: JSON.stringify(body)
			})).json()

			if (res.result !== 1) {
				throw new Error()
			}

			if (res.data.inquiries[0].status != 3) {
				if (res.data.inquiries[0].status == 4) {
					maybeAlreadyRegistered = true
				}
				throw new Error()
			}
		} catch (e) {
			const error = <p><strong>Wystąpił błąd.</strong>{maybeAlreadyRegistered ? ' Może już wcześniej się zarejestrowałaś_eś?' : ''}</p> as HTMLElement
			form.parentElement!.insertBefore(error, form.nextSibling)
			error.style.opacity = '1'
			error.style.transitionDuration = '5s'
			error.style.transitionProperty = 'opacity'
			setTimeout(() => error.style.opacity = '0', 4000)
			setTimeout(() => error.remove(), 8000)
			for (const fieldset of form.getElementsByTagName('fieldset')) {
				fieldset.disabled = false
			}
			for (const button of form.getElementsByTagName('button')) {
				button.disabled = false
			}
			form.classList.remove('disabled')
			return
		}

		const afterform = form.nextSibling

		const thanks = <p><strong>Dziękujemy! Zostałaś_eś zapisana_y. Do zobaczenia na biegu!</strong></p>
		form.parentElement!.insertBefore(thanks, afterform)

		const gifmany = <p><strong>Start jest darmowy</strong>, żeby nikt nie był wykluczony. Organizacja biegu jednak kosztuje, dlatego jeśli chcesz - przekaż nam darowiznę na organizację biegu, w wysokości 40 zł.</p>
		form.parentElement!.insertBefore(gifmany, afterform)

		const donform = DonationForm(event, userData)
		form.parentElement!.insertBefore(donform, afterform)

		submitButton.parentElement!.removeChild(submitButton)

		thanks.scrollIntoView({
			behavior: 'smooth'
		})

		try {
			fbq('track', 'CompleteRegistration', {
				content_name: event.bookero_service_name,
			})
		} catch (e) {console.log(e)}
	})
	return form
}
